import { render } from "./HomePurchases.vue?vue&type=template&id=2e159376&scoped=true"
import script from "./HomePurchases.vue?vue&type=script&lang=js"
export * from "./HomePurchases.vue?vue&type=script&lang=js"

import "./HomePurchases.vue?vue&type=style&index=0&id=2e159376&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e159376"]])

export default __exports__